<template>
  <div>
    <el-carousel
      v-if="banner.length"
      :interval="10000"
      arrow="never"
      :height="carouselHeight"
      class="video_url_wrap"
      @change="handleCarouselChange"
      :indicator-position="banner.length < 2 ? 'none':''"
    >
      <el-carousel-item v-for="(item, index) in banner" :key="index">
        <!-- image -->
        <template v-if="item.banner_type == 1">
          <div :style="{ backgroundColor: item.bg_color || '', width: '100%', height: '100%'}">
            <img v-if="item.image" :src="item.image" class="banner_img" @click="goBannerUrl(item)"/>
          </div>
        </template>
        <!-- mp4 -->
        <template v-else-if="item.banner_type == 2">
          <div class="image is-16by9" :style="{ backgroundColor: item.bg_color || '', width: '100%', height: '100%'}">
            <video
              v-if="item.mp4_url"
              :ref="`video${index}`"
              id="home_video"
              controls
              autoplay
              loop
              muted
            >
              <source :src="item.mp4_url" type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </div>
        </template>
        <!-- Yutube -->
        <template v-else-if="item.banner_type == 3">
          <div :style="{ backgroundColor: item.bg_color || '', width: '100%', height: '100%'}">
            <div class="iframe-wrap" v-html="item.video_url"></div>
          </div>
        </template>
      </el-carousel-item>
    </el-carousel>

    <!-- <div class="video_url_wrap" v-if="success && info && info.mp4_url">
      <div class="image is-16by9">
        <video
          id="home_video"
          ref="videoPlayer"
          controls
          autoplay
          loop
          muted
        >
          <source :src="info.mp4_url" type="video/mp4">
          Your browser does not support the video tag.
        </video>
      </div>
    </div> -->
    <div
      v-if="success && info && !info.mp4_url"
      id="jumbotron"
      :style="{
        backgroundImage: info && info.bg_image ? `url(${info.bg_image})` : null,
      }"
    >
      <div class="container-bg is-max-widescreen">
        <div class="columns is-centered mr-0">
          <div class="column has-text-centered slogan">
            <div>
              <h1 class="is-hidden-mobile h-title title has-text-light">
                {{ info.title }}
              </h1>
            </div>
            <!-- parent -->
            <p class="lead" v-if="config.shop_type == 0">
              <span
                v-for="(item, index) in info.tag"
                :key="index"
                class="tag is-medium is-rounded mr-2 mt-2"
                :class="index % 2 == 0 ? 'is-danger ' : 'is-info'"
              >
                {{ item }}
              </span>
            </p>
            <!-- son -->
            <div
              class="lead mt-4 is-hidden-tablet"
              v-if="config.shop_type == 1"
            >
              <div
                v-for="(item, index) in shopList"
                :key="index"
                :class="index == 0 ? '' : 'mt-4'"
              >
                <a
                  :href="`https://${item.domain}`"
                  class="tag is-primary is-large is-rounded link-name"
                >
                  <i
                    class="el-icon-location"
                    style="color: white; font-size: 18px; margin-right: 8px"
                  >
                  </i>
                  {{ item.name }}
                </a>
              </div>
            </div>
            <div
              class="lead mt-4 is-hidden-mobile"
              v-if="config.shop_type == 1"
            >
              <a
                v-for="(item, index) in shopList"
                :key="index"
                :href="`https://${item.domain}`"
                :class="
                  index !== shopList.length - 1
                    ? 'tag is-primary is-large is-rounded mr-4 link-name'
                    : 'tag is-primary is-large is-roundedtag is-primary is-large is-rounded link-name'
                "
                ><i
                  class="el-icon-location"
                  style="color: white; font-size: 18px; margin-right: 8px"
                ></i>
                {{ item.name }}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <section class="cards section">
      <div class="container">
        <div class="columns is-variable is-6-desktop is-multiline">
          <div
            class="column is-one-third"
            v-for="(item, index) in items"
            :key="index"
            @click="goNext(item)"
          >
            <div class="card is-clickable" tabindex="0">
              <div class="card-image">
                <figure class="image is-3by2">
                  <img v-if="item.image" :src="item.image" alt="Sign Waiver" />
                </figure>
              </div>
              <div class="card-content">
                <h4 class="title is-4">{{ item.home_title }}</h4>
                <p class="subtitle is-6 has-text-weight-medium">
                  {{ item.home_desc }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import { homeIndex } from "@/server/api.js";
import store from "@/store";

export default {
  components: {},
  data() {
    return {
      items: [],
      info: {},
      success: false,
      banner: [],
      carouselHeight: "",
      currentPlayingIndex: null,
    };
  },
  computed: {
    config() {
      return store.state.global.configList || {};
    },
    shopList() {
      return store.state.global.shopLists || [];
    },
  },
  created() {
    this.getInfo();
  },
  methods: {
    async getInfo() {
      try {
        const { status, data } = await homeIndex({});
        if (status == 0) {
          this.items = data.items;
          this.banner = data.banner;
          // data.info.video_url = '<iframe width="1440" height="662" src="https://www.youtube.com/embed/q_YnrgneEFE" title="Sleep Instantly in 3 Minutes 💤 Mozart Brahms Lullaby♫ Baby Fall Asleep In 3 Minutes" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen="" style="width: 100%; height: 100%;"></iframe>'
          // data.info.mp4_url = 'https://kids.zdapk.cn/storage/videos/YBM43mwZZsaEkzZUETjBGUmQ5b1COf4gLIpI9Us9.mp4';
          this.info = data.info;
          this.success = true;
          var screenWidth = window.innerWidth;
          if (screenWidth >= 769) {
            this.carouselHeight = "600px";
          } else {
            this.carouselHeight = "282px";
          }
          setTimeout(() => {
          //   if(data.info && data.info.mp4_url) {
          // var jumbotron = document.getElementById("jumbotron");
          var home_video = document.getElementById("home_video");
          if (home_video) {
            if (screenWidth >= 769) {
              // jumbotron.style.height = "600px";
              home_video.style.height = "600px";
            } else {
              // jumbotron.style.minHeight = "282px";
              // jumbotron.style.height = "auto";
              // jumbotron.style.overflow = "hidden";

              home_video.style.minHeight = "282px";
              home_video.style.height = "auto";
              home_video.style.overflow = "hidden";
            }
          }
          var iframe = document.getElementsByTagName("iframe");
          if (iframe) {
            for (let i = 0; i <= iframe.length - 1; i++) {
              iframe[i].style.width = "100%";
              iframe[i].style.height = "100%";
            }
          }
          var iframe_wrap = document.getElementsByClassName("iframe-wrap");
          if (iframe_wrap) {
            for (let i = 0; i <= iframe_wrap.length - 1; i++) {
              if (screenWidth >= 769) {
                iframe_wrap[i].style.height = "600px";
              } else {
                iframe_wrap[i].style.height = "282px";
              }
            }
          }
          //   }
          }, 100);
        }
      } catch (error) {}
    },
    goNext(item) {
      this.$router.push({
        path: item.path,
      });
    },
    handleCarouselChange(newIndex, oldIndex) {
      this.pauseAllVideos(oldIndex);
      this.currentPlayingIndex = newIndex;
      this.$nextTick(() => {
        this.playVideo(newIndex);
      });
    },
    pauseAllVideos(exceptIndex) {
      this.banner.forEach((video, index) => {
        if (index !== exceptIndex) {
          this.pauseVideo(index);
        }
      });
    },
    playVideo(index) {
      if(this.banner[index].banner_type == 2) {
        if(this.$refs[`video${index}`] && this.$refs[`video${index}`].length) {
          const video = this.$refs[`video${index}`][0];
          if (video) {
            video.play();
          }
        }
      }
    },
    pauseVideo(index) {
      if(this.banner[index].banner_type == 2) {
        if(this.$refs[`video${index}`] && this.$refs[`video${index}`].length) {
          const video = this.$refs[`video${index}`][0];
          if (video) {
            video.pause();
          }
        }
      }
    },
    handleVideoPlay(index) {
      if (index !== this.currentPlayingIndex) {
        this.pauseVideo(this.currentPlayingIndex);
        this.currentPlayingIndex = index;
      }
    },
    handleVideoPause(index) {
      if (index === this.currentPlayingIndex) {
        this.currentPlayingIndex = null;
      }
    },
    // 轮播图跳转
    goBannerUrl(item) {
      if (item.target_url) {
        window.open(item.target_url, '_blank')
      }
    }
  },
};
</script>
<style scoped>
#jumbotron {
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-blend-mode: multiply;
  height: 600px;
  background-color: #ecdde4;
  color: #fff;
  margin-top: -24px;
}
.video_url_wrap {
  margin-top: 52px;
}
.container {
  display: flex;
  flex-wrap: wrap;
  margin: -24px;
  flex-grow: 1;
  margin: 0 auto;
  position: relative;
  width: auto;
}
.card {
  background-color: #fff;
  border-radius: 6px;
  box-shadow: 0 8px 16px -4px #0a0a0a1a, 0 0 0 1px #0a0a0a05;
  color: #757763;
  max-width: 100%;
  position: relative;
  overflow: hidden;
}
.card:hover {
  top: -4px;
  left: -1px;
  box-shadow: 0 0 29px #b9b9b9, 0 0 29px #fff;
  transition: all 0.5s ease-in-out;
}
.card-image {
  display: flex;
  position: relative;
}
.card-image img {
  max-width: 100%;
}
.title.is-4 {
  font-size: 1.5rem;
}
.title {
  color: #363636;
  font-family: Rubik, sans-serif;
  font-size: 24px;
  font-weight: 600;
  line-height: 1.125;
}

.subtitle {
  color: #757763;
  font-size: 16px;
  line-height: 1.25;
  font-weight: 600 !important;
  margin-top: 4px;
}
.column {
  padding: 24px;
  box-sizing: border-box;
}
.section {
  padding: 3rem 1.5rem;
}
.columns {
  margin-left: -1.5rem;
  margin-right: -1.5rem;
  margin-top: -1.5rem;
}

.columns:last-child {
  margin-bottom: -1.5rem;
}
.columns.is-multiline {
  flex-wrap: wrap;
}
.columns.is-variable {
  --columnGap: 0.75rem;
  margin-left: calc(-1 * var(--columnGap));
  margin-right: calc(-1 * var(--columnGap));
}
.columns.is-variable > .column {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}

.home-content {
  margin: auto;
  margin: 48px auto;
}
.card-content {
  background-color: transparent;
  padding: 24px;
}
.container-bg {
  flex-grow: 1;
  margin: 0 auto;
  position: relative;
  width: auto;
}
.slogan {
  width: 100%;
  padding-top: 400px;
}
.has-text-light {
  color: #f5f5f5 !important;
}
.h-title {
  font-family: Rubik, sans-serif;
  font-weight: 600;
  line-height: 1.125;
  font-size: 48px;
  text-align: center;
  text-shadow: 0px 4px 3px rgba(0, 0, 0, 0.4), 0px 8px 13px rgba(0, 0, 0, 0.1),
    0px 18px 23px rgba(0, 0, 0, 0.1);
}
.tag:not(body).is-rounded {
  border-radius: 9999px;
}
.tag:not(body).is-large {
  font-size: 20px;
}
.tag:not(body).is-primary {
  background-color: #de4c50;
  color: #fff;
}

.mt-4 {
  margin-top: 16px !important;
}
.tag {
  font-weight: 800;
}
.tag:not(body) {
  align-items: center;
  background-color: #f5f5f5;
  border-radius: 4px;
  color: #757763;
  display: inline-flex;
  font-size: 12px;
  height: 32px;
  justify-content: center;
  line-height: 1.5;
  padding-left: 12px;
  padding-right: 12px;
  white-space: nowrap;
}
.lead {
  text-align: center;
}
.mr-4 {
  margin-right: 16px !important;
}
.tag:not(body).is-rounded {
  border-radius: 290486px;
}
.tag:not(body).is-medium {
  font-size: 1rem;
}
.tag:not(body).is-danger {
  background-color: #de4c50;
  color: #fff;
}

.tag {
  font-weight: 800;
}
.tag:not(body) {
  align-items: center;
  background-color: #f5f5f5;
  border-radius: 4px;
  color: #757763;
  display: inline-flex;
  font-size: 0.75rem;
  height: 2em;
  justify-content: center;
  line-height: 1.5;
  padding-left: 0.75em;
  padding-right: 0.75em;
  white-space: nowrap;
}
.tag:not(body).is-info {
  background-color: #276cda;
  color: #fff;
}
.mr-2 {
  margin-right: 0.5rem !important;
}
.mt-2 {
  margin-top: 0.5rem !important;
}
.is-clickable {
  cursor: pointer !important;
  pointer-events: all !important;
}
.card-image:first-child img {
  border-top-left-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
}
.mr-0 {
  margin-right: 0 !important;
}
.image {
  display: block;
  position: relative;
  width: 100%;
}
.image img {
  display: block;
  height: auto;
  width: 100%;
}
.has-text-weight-medium {
  font-weight: 500 !important;
}
@media screen and (max-width: 768px) {
  .is-hidden-mobile {
    display: none !important;
  }
  .slogan {
    width: 100%;
    padding-top: 120px;
  }
  .link-name {
    font-size: 16px !important;
  }
}
@media screen and (min-width: 769px) {
  .column.is-one-third,
  .column.is-one-third-tablet {
    flex: none;
    width: 33.3333%;
  }
  .is-hidden-tablet {
    display: none !important;
  }
  .columns:not(.is-desktop) {
    display: flex;
  }
  .column.is-one-third,
  .column.is-one-third-tablet {
    flex: none;
    width: 33.3333%;
  }
  .slogan {
    width: 100%;
    padding-top: 400px;
  }
  .link-name {
    font-size: 16px !important;
  }
}
@media screen and (min-width: 1024px) {
  .container-bg {
    max-width: 960px;
  }
  .section {
    padding: 3rem;
  }
  .columns.is-variable.is-6-desktop {
    --columnGap: 1.5rem;
  }
}
@media screen and (min-width: 1408px) {
  .home-content:not(.is-max-desktop):not(.is-max-widescreen) {
    max-width: 1344px;
  }
}
.image {
  display: block;
  position: relative;
}
.iframe-wrap {
  width: 100%;
}

#home_video {
  width: 100%;
  background: #f6f5f5;
  object-fit: fill;
}
.banner_img {
  width: 100%;
  height: 100%;
}
</style>
<style scoped>
/* 隐藏左箭头 */
.el-carousel__arrow--left {
  display: none;
}
 
/* 隐藏右箭头 */
.el-carousel__arrow--right {
  display: none;
}
</style>


// WEBPACK FOOTER //
// src/pages/home/index.vue